//region :: Imports ::
import {ReactElement, ReactNode} from 'react';
import MComponent from '../Component';
import {Dialog, DialogPositionType} from 'primereact/dialog';
import {MIcon} from '../../Icons';

//endregion

/** */
type Props = {
    title: string;
    content: string | ReactNode;
    icon?: MIcon;
    footer?: ReactNode;
    position?: DialogPositionType;
    visible: boolean;
    canClose?: boolean;
    closeOnEscape?: boolean;
    onHide?: () => void;
}

/** */
class MDialog extends MComponent<Props> {

    /** */
    public constructor(props: Props) {
        super(props);
        this.bindMethods();
    }

    /** */
    private bindMethods(): void {

        this.getContentTemplate = this.getContentTemplate.bind(this);
        this.dialog_onHide = this.dialog_onHide.bind(this);

    }

    /** */
    private getContentTemplate(): ReactNode {

        const hasIcon = this.props.icon !== undefined;
        const isMessageString = typeof this.props.content === 'string';

        return (
            <div className="flex align-items-center">
                {hasIcon && <span className={`pi ${this.props.icon!.name} ${this.props.icon!.color} text-4xl mr-3`}/>}
                {isMessageString ? <span>{this.props.content}</span> : this.props.content}
            </div>
        );

    }

    /** */
    private dialog_onHide(): void {
        this.props.onHide?.();
    }

    /** */
    public render(): ReactElement {

        const canClose = this.props.canClose ?? true;
        const closeOnEscape = this.props.closeOnEscape ?? true;

        return (
            <Dialog header={this.props.title}
                    footer={this.props.footer}
                    visible={this.props.visible}
                    position={this.props.position}
                    style={{width: '35vw'}}
                    modal={true}
                    closable={canClose}
                    closeOnEscape={closeOnEscape}
                    draggable={false}
                    resizable={false}
                    maximizable={false}
                    onHide={this.dialog_onHide}>
                <div className="flex align-items-center">
                    {this.getContentTemplate()}
                </div>
            </Dialog>
        );

    }

}

export default MDialog;
